"use strict";

exports.__esModule = true;
var _FieldSet = require("./FieldSet");
Object.keys(_FieldSet).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FieldSet[key]) return;
  exports[key] = _FieldSet[key];
});